import { FC } from 'react';

export const ScaleUnbalanced: FC = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round">
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 3v18" />
    <path d="M8 21h8" />
    <path d="M5 7l-2 5h4l-2 -5" />
    <path d="M19 10l-2 5h4l-2 -5" />
    <path d="M3 7h4" />
    <path d="M17 10h4" />
    <path d="M5 7h7" />
    <path d="M12 10h7" />
  </svg>
);

export default ScaleUnbalanced;
